import type { Row } from '@tanstack/react-table';
import { Button } from '@src/design-system/button';
import { Edit2, Eye } from 'iconsax-react';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { entities } from '@shared/constants/entities';
import { HasPermission } from '@features/roles/guards/has-permission';
import { SingleDeleteAction } from '@src/design-system/molecules/ticlick-table/actions';
import type { TPlacementHostCompany } from '@src/shared/types/placement-host-company';
import { hostCompaniesApi } from '../../services/host-companies-api';
import { CreateHostModal } from '../../pages/create/modals/create-host-modal';
import ViewHostModal from '../../pages/create/modals/view-host-modal';

interface RowActionsCellProps {
  row: Row<TPlacementHostCompany>;
}

const RowActionsCell = ({ row }: RowActionsCellProps) => {
  const { mutateAsync: deleteHostCompany, isPending } =
    hostCompaniesApi.useDelete();

  return (
    <div className='flex items-center justify-center'>
      <HasPermission
        entity={entities.placementHostCompany}
        action='change'
      >
        <Button
          variant='ghost'
          size={'iconSm'}
          className='pt-0.5'
        >
          <Dialog>
            <DialogTrigger className='cursor-pointer'>
              <Edit2
                size='16'
                className='text-gray-800'
                variant='TwoTone'
              />
            </DialogTrigger>
            <DialogContent className='max-w-[600px]'>
              <CreateHostModal
                host={row.original}
                isTableView
              />
            </DialogContent>
          </Dialog>
        </Button>
      </HasPermission>

      <HasPermission
        entity={entities.placementHostCompany}
        action='delete'
      >
        <SingleDeleteAction
          id={row.original.id}
          label='this host company'
          isLoading={isPending}
          onConfirm={(closeModal) =>
            deleteHostCompany(
              { id: row.original.id },
              { onSuccess: closeModal }
            )
          }
        />
      </HasPermission>

      <HasPermission entity={entities.placementHostCompany} action='view'>
        <Button variant='ghost' size={'iconSm'} className='pt-0.5'>
          <Dialog>
            <DialogTrigger className='cursor-pointer'>
              <Eye
                size='20'
                className='text-gray-800'
                variant='TwoTone'
              />
            </DialogTrigger>
            <DialogContent className='max-w-[600px] bg-primary-30 overflow-hidden'>
              <ViewHostModal host={row.original} />
            </DialogContent>
          </Dialog>
        </Button>
      </HasPermission>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default RowActionsCell;
